import { Box } from '@mui/material';
import cn from 'classnames';
import * as React from 'react';
import ReactTooltip from 'react-tooltip';

import { capitalize } from '../../utils/ui';

import styles from './IntegrationItem.module.scss';

interface IProps {
  className?: string;
  active?: boolean;
  onClick?: () => any;
  icon?: React.ReactNode;
  name?: string;
}

const IntegrationItem = ({ className, active, onClick, icon, name }: IProps) => {
  const tooltipText = `${capitalize(name || 'integration')} is ${active ? '' : 'not '}integrated`;

  return (
    <Box data-tip={tooltipText} data-for={`integration-tooltip-${name}`}>
      <ReactTooltip id={`integration-tooltip-${name}`} effect="solid" place="top" className={styles.tooltip} />
      <Box
        className={cn(className, styles.integrationItem, { [styles.active]: active })}
        style={{ backgroundImage: `url(${icon})` }}
        onClick={onClick}
      />
    </Box>
  );
};

export default IntegrationItem;
